module.exports = __webpack_public_path__ + "img/summary.c7c89bce.png";